import React from "react";
import { FeatureCardType } from "../types/FeatureCard";

const FeatureCard: React.FC<FeatureCardType> = ({
  heading,
  ctaCopy,
  link,
  icon,
  onClick,
}) => {
  const url = link?.ctaLink ? link?.ctaLink?.value?.data?.url : link?.ctaUrl;

  return (
    <a
      href={url}
      onClick={onClick}
      className="redesign-component no-underline feature-card group border-solid border-w-1px text-balance p-xs pb-sm md:p-sm md:pb-md max-w-[302px] sm:max-w-full md:max-w-full h-full border-md border-radius--sm border-forest-200 border-width-md hover:bg-sun-200 hover:border-sun-200 focus:bg-sun-200 focus:border-sun-200 flex flex-col"
    >
      {icon?.image && (
        <img
          src={icon?.image}
          alt={icon?.imageAltText}
          className="feature-card__icon mb-xs w-8 h-8"
        />
      )}
      <h3 className="feature-card__heading group-has-[.feature-card\_\_copy]:mb-xs md:min-h-16 min-h-[70px] body--text-extra-large">
        {heading}
      </h3>
      {ctaCopy ? (
        <span className="feature-card__copy text-forest-900 pb-[3px] mt-auto md:mt-0 group-hover:no-underline group-focus:no-underline font-semibold leading-[25px] text-balance w-fit underline decoration-[1.5px] decoration-sun-600 transition-all duration-500 underline-offset-4 ">
          {ctaCopy}
        </span>
      ) : null}
    </a>
  );
};

export default FeatureCard;
